<template>
  <div>
    <div class="container">
      <div class="row px-3 py-4 mb-4">
        <div class="col-md-12 d-flex align-items-start flex-wrap gap-4">

          <label for="dataTable" class="iot-station  mt-1">Flow Management</label>

          <!-- Schema Label + Dropdown -->
          <div class="d-flex align-items-center">
            <label for="time-range-select" class="custom-label me-1">Hub:</label>
            <select id="schemaSelect" class="form-select form-select-sm shadow-none custom-input custom-dropdown w-auto" 
            v-model="selectedFlowMgmtHub">
              <option v-for="hub in FlowMgmtHubOptions" :key="hub.uuid" :value="hub.uuid">
            {{ hub.name }}
          </option>
            </select>
          </div>

          <!-- Type Label + Dropdown -->
          <div class="d-flex align-items-center">
            <label for="time-range-select" class="custom-label me-1">Controller:</label>
            <select class="form-select form-select-sm shadow-none custom-input custom-dropdown w-auto" 
            v-model="selectedFlowMgmtController">
              <option v-for="controller in flowMgmtcontrollerOptions" :key="controller.uuid" :value="controller.uuid">
            {{ controller.name }}
          </option>
            </select>
          </div>

          <!-- Status Label + Dropdown + Text + Error -->
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center">
              <label class="custom-label me-1">Tag Number:</label>
              <div class="custom-multiple-dropdown-wrapper me-2">
  <select class="form-select-sm form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect" style="width: 120px;"
    v-model="selectedTagNumber">
    <option value="" disabled selected>Select Option</option>
    <option v-for="tag in tagNumberOptions" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
  </select>
  <button @click="updateselectedTagNumber(selectedTagNumber)" class="multiple-dropdown-add-button">+</button>
</div>
              
              <!-- Inline text -->
              <div class="form-group align-self-end custom-input">
<div v-if="selectedTagNumberOptions.length > 0" class="custom-multiple-dropdown-container">
  <div v-for="(tag, index) in selectedTagNumberOptions" :key="index">
    <span class="custom-multiple-dropdown"  :title="tag.name.length > 20 ? tag.name : ''">{{
          tag.name.length > 20 
            ? tag.name.slice(0, 19) + '...'
            : tag.name
        }}
      <button class="multiple-dropdown-delete-icon" @click="removeselectedTagNumber(index)">
        <dropdownDeleteIcon />
      </button>
    </span>
  </div>
</div>
</div>
            </div>
            <!-- Error Message -->
            <div>  <small v-if="selectedTagNumberOptions.length === 0" class="text-danger ms-5" style=" font-size: 11px;">Select Tag Number</small>
<small v-if="maxTagNumMessage" class="text-danger me-5" style=" font-size: 11px;">
  {{ maxTagNumMessage }}
</small></div>
          </div>

        </div>
      </div>
      <div  v-if="loading" class="row" style="margin-top: 95px;">
<!-- <div  class=" chart-wrapper position-relative"> -->
  <div  class=" d-flex justify-content-center align-items-center">
    <div class="spinner-border text-primary"></div>
  <!-- </div> -->
</div>
</div>

      <div v-else-if="!apiError" class="d-flex justify-content-between px-5">
<!-- Gauge Column -->
<div class="col-12 col-md-3" v-if="selectedTagNumberOptions.length >= 1 && isGauge1Visible">
  <div class="mb-4">
    <label class="iot-station">Tag Number : {{ gauge1.tag }}</label>
  </div>
  <div class="gauge-wrapper" >
    <svg viewBox="0 0 200 100" class="gauge-svg">
      <!-- Background arc -->
      <path d="M10,100 A90,90 0 0,1 190,100" fill="none" stroke="#eee" stroke-width="20"/>

      <!-- Filled arc -->
      <path 
        :d="getArcPath(gauge1.value, gauge1.capacity)"
        fill="none" 
        stroke="url(#gradient)" 
        stroke-width="20"
        stroke-linecap="round"
      />

      <!-- Gradient -->
      <defs>
        <linearGradient id="gradient" x1="0%" y1="100%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#018ffb"/>
          <stop offset="100%" stop-color="#00e296"/>
        </linearGradient>
      </defs>

      <!-- Sleek Needle Group -->
      <g class="needle-group" :style="{ transform: 'rotate(' + getNeedleAngle(gauge1.value, gauge1.capacity) + 'deg)' }">
        <!-- Needle shape (triangle) -->
        <polygon points="100,30 97,100 103,100" fill="red" />

        <!-- Center hub circle -->
        <circle cx="100" cy="97" r="6" fill="#333" />
      </g>

      <!-- Tick Labels -->
      <text x="6" y="100" class="ticks">0</text>
      <text :x="gauge1.capacity.toString().length > 5 ? 153 :
gauge1.capacity.toString().length > 4 ? 160 :
gauge1.capacity.toString().length > 3 ? 163 : 178" y="100" class="ticks">
{{ gauge1.capacity }}
</text>

    </svg>

    <div class="value-label">{{ gauge1.value }}</div>
  </div>
</div>
<!-- <div v-else class="col-12 col-md-3 d-flex justify-content-center align-items-center mt-5" >
    <p v-if="selectedTagNumberOptions.length === 0" class="text-muted">Please select at least one Tag Number.</p>
    <p v-else-if="noRecordFound" class="text-muted">No record Found</p>
</div> -->
<div v-else class="col-12 col-md-3 d-flex justify-content-center align-items-center mt-5" >
  <p v-if="selectedTagNumberOptions.length === 0" class="text-muted">Please select at least one Tag Number.</p>
  <div v-else-if="selectedTagNumberOptions.length >= 1 && noRecordFound">
    <label class="iot-station d-block mb-3">Tag Number : {{ selectedTagNumberOptions[0].id }}</label>
    <span class="text-muted">
      No Record Found
    </span>
</div>
</div>


<!-- Value Box Column -->
<div class=" mt-5" v-if="selectedTagNumberOptions.length >= 1 && isGauge1Visible">
  <div class="value-box mb-3 d-flex p-3 shadow-sm rounded ">
    <div class="title me-1">Totalizer : </div>
    <div class="value">{{ gauge1.totalizer }}</div>
  </div>
  <div class="value-box d-flex p-3 shadow-sm rounded ">
    <div class="title me-1">Daily Total : </div>
    <div class="value">{{ gauge1.consumption }}</div>
  </div>
</div>
<div class="border-end "></div>
<div class="col-12 col-md-3"  v-if="selectedTagNumberOptions.length === 2 && isGauge2Visible">
  <div class="mb-4">
    <label class="iot-station">Tag Number : {{ gauge2.tag }}</label>
  </div>
  <div class="gauge-wrapper" >
    <svg viewBox="0 0 200 100" class="gauge-svg">
      <!-- Background arc -->
      <path d="M10,100 A90,90 0 0,1 190,100" fill="none" stroke="#eee" stroke-width="20"/>

      <!-- Filled arc -->
      <path 
       :d="getArcPath(gauge2.value, gauge2.capacity)"
        fill="none" 
        stroke="url(#gradient)" 
        stroke-width="20"
        stroke-linecap="round"
      />

      <!-- Gradient -->
      <defs>
        <linearGradient id="gradient" x1="0%" y1="100%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#018ffb"/>
          <stop offset="100%" stop-color="#00e296"/>
        </linearGradient>
      </defs>

      <!-- Sleek Needle Group -->
      <g class="needle-group" :style="{ transform: 'rotate(' + getNeedleAngle(gauge2.value, gauge2.capacity) + 'deg)' }">
        <!-- Needle shape (triangle) -->
        <polygon points="100,30 97,100 103,100" fill="red" />

        <!-- Center hub circle -->
        <circle cx="100" cy="97" r="6" fill="#333" />
      </g>

      <!-- Tick Labels -->
      <text x="6" y="100" class="ticks">0</text>
      <text :x="gauge2.capacity.toString().length > 5 ? 153 :
gauge2.capacity.toString().length > 4 ? 160 :
gauge2.capacity.toString().length > 3 ? 163 : 178" y="100" class="ticks">
{{ gauge2.capacity }}
</text>
    </svg>

    <div class="value-label">{{ gauge2.value }}</div>
  </div>
</div>
<!-- <div v-else class="col-12 col-md-3 d-flex justify-content-center align-items-center mt-5">
    <p v-if="selectedTagNumberOptions.length === 1" class="text-muted">Select one more Tag Number to view comparison.</p>
    <p v-else-if="selectedTagNumberOptions.length === 0" class="text-muted">Please select at least one Tag Number.</p>
    <p v-else-if="selectedTagNumberOptions.length === 2 && noRecordFound" class="text-muted">No record Found</p>
</div> -->
<div v-else class="col-12 col-md-3 d-flex justify-content-center align-items-center mt-5">
    <p v-if="selectedTagNumberOptions.length === 1" class="text-muted">Select one more Tag Number to view comparison.</p>
    <p v-else-if="selectedTagNumberOptions.length === 0" class="text-muted">Please select at least one Tag Number.</p>
    <!-- <p v-else-if="selectedTagNumberOptions.length === 2 && noRecordFound" class="text-muted">No record Found</p> -->
    <div v-else-if="selectedTagNumberOptions.length === 2 && noRecordFound">
  <label class="iot-station d-block mb-3">
    Tag Number : {{ selectedTagNumberOptions[1].id }}
    </label>
  
  <span class="text-muted">
      No Record Found
    </span>
</div>

  </div>
<!-- Value Box Column -->
<div class="mt-5"  v-if="selectedTagNumberOptions.length === 2 && isGauge2Visible">
  <div class="value-box mb-3 d-flex p-3 shadow-sm rounded ">
    <div class="title me-1">Totalizer :</div>
    <div class="value">{{ gauge2.totalizer }} </div>
  </div>
  <div class="value-box d-flex p-3 shadow-sm rounded ">
    <div class="title me-1">Daily Total :</div>
    <div class="value">{{ gauge2.consumption }} </div>
  </div>
</div>
</div>

     
    </div>
  </div>
</template>

<script>
import { ddReportComponent, ddReportHub } from '@/http/dashboard/report.http';
import { getFlowMgmtData, ddTagNumber } from '@/http/dashboard/iot-insight.http';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'graph1',
  components: {
    dropdownDeleteIcon
  },
  data() {
    
    return {
       apiError: false,
      suppressFlowMgmtControllerWatcher: false,
      noRecordFound: false,
      isFlowMgmtTimer: 0,
      loading: false,
      tagNumberOptions: [],
    FlowMgmtHubOptions: [],
    flowMgmtcontrollerOptions: [],
    selectedTagNumberOptions: [],
    selectedFlowMgmtHub: '',
    selectedFlowMgmtController: '',
    maxTagNumMessage: '',
    selectedTagNumber: '',
    gauge1: {
    tag: '',
    value: 0,
    capacity: 100,
    totalizer: 0,
    consumption: 0
  },
  gauge2: {
    tag: '',
    value: 0,
    capacity: 100,
    totalizer: 0,
    consumption: 0
  },
      breadcrumsfirst: 'Dashboard',
      breadcrumslast: 'IoT Insights',
    };
  },
 
   async mounted(){
     await this.fetchFlowMgmtHubOptions();
    //  await this.fetchflowMgmtcontrollerOptions();
    //  await this.fetchDDTagNumber();
     this.flowMgmtTimer = setInterval(() => {
    this.isFlowMgmtTimer = 1
      this.fetchFlowMgmtData()
    }, 5000);
    },
    beforeUnmount() {
    clearInterval(this.flowMgmtTimer);
  },
  computed: {
  isGauge1Visible() {
    return this.gauge1.tag !== '';
  },
  isGauge2Visible() {
    return this.gauge2.tag !== '';
  }
},

    watch: {
      async selectedFlowMgmtHub(newHubId) {
    this.suppressFlowMgmtControllerWatcher = true;
    await this.fetchflowMgmtcontrollerOptions(newHubId);
    // this.fetchFlowMgmtData(); // call from hub change
    this.suppressFlowMgmtControllerWatcher = false;
  },
  selectedFlowMgmtController() {
    if (this.suppressFlowMgmtControllerWatcher) return;
    this.fetchDDTagNumber(this.selectedFlowMgmtController); 
    // this.fetchFlowMgmtData(); // only call when not triggered by hub change
  },
selectedTagNumberOptions: {
  handler: 'fetchFlowMgmtData',
  deep: true
}
},
methods:{

  async fetchFlowMgmtHubOptions() {
try {
  const response = await ddReportHub();
  this.FlowMgmtHubOptions = response || [];

  if (this.FlowMgmtHubOptions.length > 0) {
    this.selectedFlowMgmtHub = this.FlowMgmtHubOptions[0].uuid;
  } else {
    this.selectedFlowMgmtHub = '';
  }

} catch (error) {
  console.error('Error fetching hub options:', error);
  this.FlowMgmtHubOptions = [];
  this.selectedFlowMgmtHub = '';
}
},

async fetchflowMgmtcontrollerOptions(hubId) {
  try {
    const response = await ddReportComponent({ id: hubId || "" });
    this.flowMgmtcontrollerOptions = response || [];
    if (this.flowMgmtcontrollerOptions.length > 0) {
      this.selectedFlowMgmtController = this.flowMgmtcontrollerOptions[4].uuid;
      // 🔑 Trigger tag number API for default controller
      await this.fetchDDTagNumber(this.selectedFlowMgmtController);
    } else {
      this.selectedFlowMgmtController = '';
      this.tagNumberOptions = []; // Clear tag numbers if no controller
      this.selectedTagNumberOptions = [];
    }
  } catch (error) {
    console.error('Error fetching controller options:', error);
    this.flowMgmtcontrollerOptions = [];
    this.selectedFlowMgmtController = '';
    this.tagNumberOptions = [];
    this.selectedTagNumberOptions = [];
  }
},
  async fetchDDTagNumber(controllerId ) {
try {
  this.tagNumberOptions = await ddTagNumber({id: controllerId || ""});

  this.selectedTagNumberOptions = this.tagNumberOptions.slice(0, 2).map(tag => ({ id: tag.id, name: tag.name }));
} catch (error) {
  console.error("Error fetching data:", error);
}
},
  async fetchFlowMgmtData() {
    if(this.isFlowMgmtTimer == 0){
        this.loading = true;
       
      }

      // this.noRecordFound = false;
if ( !this.selectedFlowMgmtHub ||
!this.selectedFlowMgmtController) {
  this.loading = false;
  this.noRecordFound = true
  return;
}

if ( this.selectedTagNumberOptions.length === 0) {
  this.gauge1 = { tag: '', value: 0, capacity: 100, totalizer: 0, consumption: 0 };
  this.gauge2 = { tag: '', value: 0, capacity: 100, totalizer: 0, consumption: 0 };
  this.loading = false;
  return;
}
const payload = {
  hubid: this.selectedFlowMgmtHub || "",
  controllerid: this.selectedFlowMgmtController || "",
  ids: this.selectedTagNumberOptions.map(tag => tag.id).join(",")
};


try {
  const response = await getFlowMgmtData(payload);

  if (!response || response.length === 0 || typeof response === 'string' || !Array.isArray(response) || Object.keys(response).length === 0
  ||  response.some(item => !item.timestamp || item.timestamp === "")) {
    // Reset both if response is empty or null
    this.noRecordFound = true;
    this.gauge1 = { tag: '', value: 0, capacity: 100, totalizer: 0, consumption: 0 };
    this.gauge2 = { tag: '', value: 0, capacity: 100, totalizer: 0, consumption: 0 };
    return;
  }

  // Set first gauge if available
  // this.noRecordFound = false;
       response.sort((a, b) => {
        if (a.physicalid < b.physicalid) return -1;
        if (a.physicalid > b.physicalid) return 1;
        return 0;
      });
      
  const selectedIds = this.selectedTagNumberOptions.map(tag => tag.id);
const responseByTag = {};
response.forEach(item => {
  if (item && item.physicalid) {
    responseByTag[item.physicalid] = item;
  }
});

this.noRecordFound = false;
 this.apiError = false;

// Gauge 1
const tag1 = selectedIds[0];
const data1 = responseByTag[tag1];
if (data1) {
  this.gauge1 = {
    tag: data1.physicalid || '',
    value: data1.value || 0,
    capacity: data1.capacity || 100,
    totalizer: data1.totalizer || 0,
    consumption: data1.consumption || 0
  };
} else {
  this.gauge1 = { tag: '', value: 0, capacity: 100, totalizer: 0, consumption: 0 };
  this.noRecordFound = true; // you could set a separate flag for tag1 if needed
}

// Gauge 2 (if applicable)
if (selectedIds.length > 1) {
  const tag2 = selectedIds[1];
  const data2 = responseByTag[tag2];
  if (data2) {
    this.gauge2 = {
      tag: data2.physicalid || '',
      value: data2.value || 0,
      capacity: data2.capacity || 100,
      totalizer: data2.totalizer || 0,
      consumption: data2.consumption || 0
    };
  } else {
    this.gauge2 = { tag: '', value: 0, capacity: 100, totalizer: 0, consumption: 0 };
    this.noRecordFound = true; // again, optional per-tag flag
  }
}


} catch (error) {
  console.error('Error fetching Sensor Details data:', error);
      this.apiError = true;
  // Reset both gauges on error too
  // this.noRecordFound = true;
  // this.gauge1 = { tag: '', value: 0, capacity: 100, totalizer: 0 };
  // this.gauge2 = { tag: '', value: 0, capacity: 100, totalizer: 0 };
} finally {
  this.loading = false;
  this.isFlowMgmtTimer = 0;
}
},

updateselectedTagNumber(selectedTagNumber) {
    if (this.selectedTagNumberOptions.length >= 2) {
      this.maxTagNumMessage = 'You can select a maximum of 2 Tag Number.';
      return;
    } else {
      this.maxTagNumMessage = ''; // Clear the message if the limit is not reached
    }

    const tag = this.tagNumberOptions.find(tag => tag.id === selectedTagNumber);
    if (tag && !this.selectedTagNumberOptions.some(t => t.id === tag.id)) {
      this.selectedTagNumberOptions.push({ id: tag.id, name:tag.name });
    }
  },
  
  removeselectedTagNumber(index) {
    this.selectedTagNumberOptions.splice(index, 1);
    if (this.selectedTagNumberOptions.length < 3) {
      this.maxTagNumMessage = '';
    }
  },
  getNeedleAngle(value, capacity) {
const clamped = Math.min(Math.max(value, 0), capacity);
const percent = clamped / capacity;
return -90 + percent * 180;
},
getArcPath(value, capacity) {
const clamped = Math.min(Math.max(value, 0), capacity);
const percent = clamped / capacity;
const angle = Math.PI * percent;
const radius = 90;
const x = 100 + radius * Math.cos(Math.PI - angle);
const y = 100 - radius * Math.sin(angle);
return `M10,100 A90,90 0 0,1 ${x},${y}`;
},

}
};

</script>

<style scoped>
.gauge-wrapper {
    width: 100%;
    max-width: 280px;
    margin: 0;
    position: relative;
  }

  .gauge-svg {
    width: 100%;
    height: auto;
  }

  .needle-group {
    transform-origin: 100px 100px;
    transition: transform 0.5s ease-in-out;
  }

  .value-label {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 60%;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .ticks {
    font-size: 0.81rem;
    fill: #000000;
  }
  .value-box{
    color: #fff;
    /* background-image: linear-gradient( 135deg, #ABDCFF 10%, #018ffb 50%, #00e296 100%); */
    background-image: linear-gradient( 135deg, #018ffb 25%, #00e296 140%);
  }

</style>